export class StorageConf {

  static USER_NAME_KEY = 'us';
  static PASSWORD_KEY = 'pass';

}
